import { SimpleDatePicker } from "@/components/DatePicker/SimpleDatePicker";
import { FillScreen } from "@/components/Layout";
import { ViewportLoader } from "@/components/Loading";
import {
  createFileRoute,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { EmptyState } from "../../-components/EmptyState";
import OrganizationToolbar from "../../-components/OrganizationToolbar";
import { HierarchyView } from "../../-components/views/HierarchyView";
import { TableView } from "../../-components/views/TableView";
import { TreeView } from "../../-components/views/TreeView";
import { ViewMode } from "../../-constant";
import useOrganizationChart from "./-useOrganizationChart";
import { SearchSchema } from "./-zod-schema";

export const Route = createFileRoute("/_staff/organization/_list/chart/")({
  component: OrganizationPage,
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => ({ search }),
});

function OrganizationPage() {
  const navigate = useNavigate();
  const { baseDate } = useSearch({ strict: false });

  const {
    viewMode,
    isCompactView,
    data,
    isLoading,
    isEmpty,
    toolbarProps,
    dateProps,
    hierarchyLabels,
    hierarchyViewRef,
    treeViewRef,
    tableViewRef,
  } = useOrganizationChart();

  return (
    <FillScreen className="flex flex-col gap-3 px-12 py-5">
      <div className="w-fit bg-white rounded-md">
        <SimpleDatePicker
          value={dateProps.date ? new Date(dateProps.date) : undefined}
          onChange={dateProps.onDateChange}
        />
      </div>
      <OrganizationToolbar {...toolbarProps} />
      {isLoading ? (
        <ViewportLoader />
      ) : isEmpty ? (
        <EmptyState />
      ) : (
        <>
          {viewMode === ViewMode.HIERARCHY && (
            <HierarchyView organizations={data ?? []} ref={hierarchyViewRef} />
          )}
          {viewMode === ViewMode.TREE && (
            <TreeView
              organizations={data ?? []}
              isCompact={isCompactView}
              hierarchyLabels={hierarchyLabels}
              ref={treeViewRef}
            />
          )}
          {viewMode === ViewMode.TABLE && (
            <TableView
              organizations={data ?? []}
              hierarchyLabels={hierarchyLabels}
              onRowClick={(row) => {
                navigate({
                  to: "/organization/$id",
                  params: { id: row.id },
                  search: { baseDate },
                });
              }}
              ref={tableViewRef}
            />
          )}
        </>
      )}
    </FillScreen>
  );
}
